<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="processedDataSource"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
        @change="handleTableChange"
      >
        <template slot="staffId" slot-scope="staff_id">
        <span class="font-weight-bold">{{ staff_id }}</span>
        </template>

        <template slot="system_staff_id" slot-scope="system_staff_id">
        <span class="font-weight-bold">{{ system_staff_id }}</span>
        </template>

        <template slot="name" slot-scope="name">
        <span class="font-weight-bold">{{ name }}</span>
        </template>

        <template slot="staffTitle" slot-scope="staffTitle">
        <span class="text-wrap">{{ staffTitle }}</span>
        </template>

        <template slot="subject" slot-scope="subject">
        <span class="font-weight-bold">{{ subject }}</span>
        </template>

        <template slot="email" slot-scope="email">
        <span class="text-wrap">{{ email }}</span>
        </template>

        <template slot="phone" slot-scope="phone">
        <span class="font-weight-bold">
        {{ phone.phone ? phone.country_code + phone.phone : '' }}
        </span>
        </template>

        <template slot="qualification" slot-scope="qualification">
        <span class="font-weight-bold">{{ qualification }}</span>
        </template>

        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Edit -->
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-staff ref="editStaff" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>

    <edit-staff ref="editStaff" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'
import EditStaff from '@/components/staff/Forms/Edit/index'

const columns = [
  {
    title: 'Staff Code',
    className: 'text-left',
    dataIndex: 'staff_id',
    width: '10%',
    scopedSlots: { customRender: 'staffId' },
    // sorter: (a, b) => a.staff_id.localeCompare(b.staff_id),
    sorter: true,
  },
  {
    title: 'System Staff Id',
    dataIndex: 'system_staff_id',
    className: 'text-left',
    width: '12%',
    key: 'system_staff_id',
    scopedSlots: { customRender: 'system_staff_id' },
    // sorter: (a, b) => a.system_staff_id.localeCompare(b.system_staff_id),
    sorter: true,
  },
  {
    title: 'Staff Name',
    className: 'text-left text-gray-6',
    width: '20%',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    // sorter: (a, b) => a.first_name.localeCompare(b.first_name),
    sorter: true,
  },
  {
    title: 'Staff Title',
    dataIndex: 'title',
    scopedSlots: { customRender: 'staffTitle' },
    // sorter: (a, b) => a.title.localeCompare(b.title),
  },
  // {
  //   title: 'Address',
  //   dataIndex: 'contacts[0].address',
  //   key: 'contacts[0].address',
  //   scopedSlots: { customRender: 'address' },
  //   // sorter: (a, b) => a.contacts[0].address.localeCompare(b.contacts[0].address),
  // },
  {
    title: 'Email',
    dataIndex: 'contacts[0].email',
    width: '20%',
    key: 'contacts[0].email',
    scopedSlots: { customRender: 'email' },
    // sorter: (a, b) => a.contacts[0].address.localeCompare(b.contacts[0].address),
  },
  {
    title: 'Phone No',
    dataIndex: 'contacts[0]',
    key: 'contacts[0].phone',
    scopedSlots: { customRender: 'phone' },
    // sorter: (a, b) => a.contacts[0].phone.localeCompare(b.contacts[0].phone),
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'StaffsTable',
  components: {
    EditStaff,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    processedDataSource() {
      return this.data.map(item => ({
        ...item,
        name: [item.first_name, item.last_name].map(val => (val && val !== 'null' ? val.trim() : '')).filter(Boolean).join(' '),
      }))
    },
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    handleTableChange: function (pagination, filters, sorter) {
      let sortColumn = sorter.field === 'name' ? 'first_name' : sorter.field
      this.$emit('updateTable', [sortColumn, sorter.order])
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editStaff.showModal(record.id)
      this.$eventBus.$emit('openStaffEditModal', record.id)
    },
    handleEdited: function (updatedStaff) {
      // Find the index of the updated staff in the data array
      const index = this.data.findIndex(staff => staff.id === updatedStaff.id)

      if (index !== -1) {
        // Use Vue.set for reactive update
        this.$set(this.data, index, {
          ...this.data[index],
          ...updatedStaff,
          name: `${updatedStaff.first_name} ${updatedStaff.last_name}`,
        })
      }
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this staff?',
        content: 'Clicking yes will delete this staff from the school.',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/teacher/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'The staff has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
